import React, { ChangeEvent, Component } from 'react';
import classNames from 'classnames';
import { WrappedComponentProps, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';

import style from '../Fields.module.scss';

import { Omit } from 'helpers/types';

interface Props
  extends Omit<React.InputHTMLAttributes<HTMLTextAreaElement>, 'onChange'> {
  invalid?: boolean;
  onChange: (v: string, event: any) => void;
  showLimit?: boolean;
  rows?: number;
}

@observer
class TextArea extends Component<Props & WrappedComponentProps> {
  textarea = React.createRef<HTMLTextAreaElement>();

  componentDidMount() {
    if (this.textarea.current) {
      this.resize(this.textarea.current);
    }
  }

  handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    const { target } = event;
    this.resize(target);

    this.props.onChange(target.value, event);
  };

  getMinHeight = (el: HTMLTextAreaElement) => {
    const { rows } = this.props;
    if (!el || !rows) return 0;

    const lineHeight = parseFloat(getComputedStyle(el).fontSize) * 1.2;
    return lineHeight * rows;
  };

  resize = (el: HTMLTextAreaElement) => {
    el.style.height = 'auto';
    const minHeight = this.getMinHeight(el);

    el.style.height = `${Math.max(el.scrollHeight, minHeight)}px`;
  };

  render() {
    const { className, invalid, showLimit = false, rows, ...rest } = this.props;
    const value = String(rest.value);

    return (
      <div className={classNames(style.textarea)}>
        <textarea
          {...rest}
          rows={rows || 1}
          className={classNames(style.field, className, {
            [style.field__invalid]: invalid,
          })}
          onChange={this.handleChange}
          ref={this.textarea}
        />

        {showLimit && (
          <span
            className={classNames(style.area__limit, {
              [style.value__max]: value.length === rest.maxLength,
            })}
          >
            {value.length} / {rest.maxLength}
          </span>
        )}
      </div>
    );
  }
}

export default injectIntl(TextArea);
